/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Pressmeddelanden - CamAPS FX',
    titleMeta: 'Pressmeddelanden - CamAPS FX',
    descriptionMeta: 'Senaste pressmeddelanden och nyheter från CamAPS FX.',
    keywords: 'camaps pressmeddelanden, camaps nyheter, diabetes teknologi nyheter',
    localeMeta: 'sv_se',

    bannerTitle: 'Pressmeddelanden',
    bannerSubtitle: 'Håll dig uppdaterad med våra senaste meddelanden',

    contactText: 'För pressfrågor, kontakta via <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Alla pressmeddelanden publiceras på engelska.',

    download: 'Ladda ner',
    showMore: 'Visa mer',
    showLess: 'Visa mindre',
};

